import type { ReactNode } from 'react';
import { Box, TextField, InputAdornment, Button, Stack } from '@mui/material';
import { Search, FileDownloadOutlined } from '@mui/icons-material';

interface Props {
  search?: string;
  onSearch?: (value: string) => void;
  searchPlaceholder?: string;
  /** Extra filter controls (selects, etc.). */
  filters?: ReactNode;
  /** Called when the export button is clicked; omit to hide the button. */
  onExport?: () => void;
  /** Action buttons (e.g. "New …") rendered on the right. */
  actions?: ReactNode;
}

/** Reusable list toolbar: search + filters + export + actions. */
export function TableToolbar({ search, onSearch, searchPlaceholder = 'Search…', filters, onExport, actions }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
        {onSearch && (
          <TextField
            size="small"
            value={search ?? ''}
            onChange={(e) => onSearch(e.target.value)}
            placeholder={searchPlaceholder}
            sx={{ minWidth: 240 }}
            InputProps={{ startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment> }}
          />
        )}
        {filters}
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        {onExport && <Button size="small" variant="outlined" startIcon={<FileDownloadOutlined />} onClick={onExport}>Export</Button>}
        {actions}
      </Stack>
    </Box>
  );
}
